"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _routesPropType = require("./routesPropType");

var _createDefaultContainsActiveRouteChecker = require("./createDefaultContainsActiveRouteChecker");

var _createDefaultActiveRouteChecker = require("./createDefaultActiveRouteChecker");

var _createTransformRoutes = require("./createTransformRoutes");

var _NavListStateless = _interopRequireDefault(require("./NavListStateless"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NavList = function NavList(_ref) {
  var routes = _ref.routes,
      currentPath = _ref.currentPath,
      _ref$activeRouteCheck = _ref.activeRouteChecker,
      activeRouteChecker = _ref$activeRouteCheck === void 0 ? (0, _createDefaultActiveRouteChecker.createDefaultActiveRouteChecker)(currentPath) : _ref$activeRouteCheck,
      _ref$containsActiveRo = _ref.containsActiveRouteChecker,
      containsActiveRouteChecker = _ref$containsActiveRo === void 0 ? (0, _createDefaultContainsActiveRouteChecker.createDefaultContainsActiveRouteChecker)(currentPath) : _ref$containsActiveRo,
      otherProps = _objectWithoutProperties(_ref, ["routes", "currentPath", "activeRouteChecker", "containsActiveRouteChecker"]);

  var transformRoutes = (0, _createTransformRoutes.createTransformRoutes)(activeRouteChecker, containsActiveRouteChecker);

  var _useState = (0, _react.useState)(transformRoutes(routes)),
      _useState2 = _slicedToArray(_useState, 2),
      routeItems = _useState2[0],
      setRouteItems = _useState2[1];

  (0, _react.useEffect)(function () {
    setRouteItems(transformRoutes(routes));
  }, // eslint-disable-next-line
  [routes]);
  (0, _react.useEffect)(function () {
    var newRouteItems = transformRoutes(routeItems);
    if (JSON.stringify(newRouteItems) === JSON.stringify(routeItems)) return;
    setRouteItems(newRouteItems); // eslint-disable-next-line
  }, [currentPath, routeItems]);

  var toggleCollapse = function toggleCollapse(clickedRouteKey) {
    var newRouteItems = routeItems.map(function (route) {
      return route.key === clickedRouteKey ? _objectSpread({}, route, {
        isOpen: !route.isOpen
      }) : _objectSpread({}, route, {
        isOpen: false
      });
    });
    setRouteItems(transformRoutes(newRouteItems));
  };

  return _react.default.createElement(_NavListStateless.default, _extends({
    toggleCollapse: toggleCollapse,
    routes: routeItems
  }, otherProps));
};

NavList.propTypes = {
  isMenu: _propTypes.default.bool,
  style: _propTypes.default.object,
  onClick: _propTypes.default.func,
  itemProps: _propTypes.default.object,
  linkProps: _propTypes.default.object,
  isNestedMenu: _propTypes.default.bool,
  activeRouteChecker: _propTypes.default.func,
  containsActiveRouteChecker: _propTypes.default.func,
  routes: _routesPropType.routesPropType,
  currentPath: _propTypes.default.string.isRequired
};
var _default = NavList;
exports.default = _default;